/* eslint-disable */
// 组成*字符串
const star = (len) => ''.padStart(len, '*')
// String.protoype.replace的第2参数, 将匹配的字符串转化为星星
const starCallback = (matched, $1, offset, whole) => (whole ? star($1.length) : star(matched.length))
// 正则替换生成函数
const regReplacer = (reg, start, end) => (str) => {
  return str.replace(reg, starCallback).slice(start, end)
}
function warn(msg) {
  console.warn(`Masker: ${msg}`)
}

export const rules = [
  // 手机号
  {
    type: 'MOBILE_NUM',
    match: /^999\d{15}$/,
    format: (str) => str.slice(3, 6) + '****' + str.slice(-4)
  },

  // 固定电话
  {
    type: 'TELEPHONE_NUM',
    match: /^\d{4}[a-zA-Z]{4}\d+#$/,
    format: regReplacer(/[a-zA-Z]+/, 0, -1)
  },

  // 身份证
  {
    type: 'ID_NUM',
    match: /^\d{6}[a-zA-Z]{9}(\d{3}|\d{2}[xX])#$/,
    format: regReplacer(/\d{3}[a-zA-Z]{9}/, 0, -1)
  },

  // 地址
  {
    type: 'ADDRESS',
    match: /^[\s\S]*{{\w+}}[\s\S]*{M}$/,
    format: regReplacer(/{{([a-zA-Z]+)}}/, 0, -3)
  },

  // 邮箱
  {
    type: 'EMAIL',
    match: /^[\w\.-]+{[a-zA-Z]+}@[\w\.-]+#$/,
    format: regReplacer(/{([a-zA-Z]+)}/, 0, -1)
  },

  // 银行卡
  {
    type: 'CARD_NO',
    match: /^\d{6}[a-zA-Z]{6}\d{4}$/,
    format: regReplacer(/\w*(?=\d{4}$)/)
  },

  // 驾驶证-档案编号
  {
    type: 'DRIVING_LICENCE_NUM',
    match: /^\d{6}[a-zA-Z]{6}#$/,
    format: (str) => str.slice(0, 4) + '********'
  },

  // 行驶证-车牌号码
  {
    type: 'PLATE_NUMBER',
    match: /^[\u4e00-\u9fa5]\w{2}[a-zA-Z]{6}(\w|[\u4e00-\u9fa5])#$/,
    format: (str) => str.slice(0, 3) + '*****' + str.slice(-2, -1)
  },

  // 行驶证-车辆识别代号
  {
    type: 'VIN_NO',
    match: /^\w{3}[a-zA-Z]{10}\w{4}#$/,
    format: (str) => str.slice(0, 3) + '************' + str.slice(-3, -1)
  },

  // 系统账号
  {
    type: 'ACCOUNT_NAME',
    match: /^\w+{{[a-zA-Z]{6}}}#$/,
    format: (str) => str.replace(/{{\w{6}}}#/, '') + '****'
  },

  // 姓名
  {
    type: 'USER_NAME',
    match: /^[\u4e00-\u9fa5]{2,}$/,
    request: false,
    format: (str) => str[0] + '**'
  },

  // 定位坐标
  {
    type: 'MAP_COORDINATE',
    match: /^-?\d{1,3}\.\d{3,}$/,
    request: false,
    format: ((reg) => (str) => str.replace(reg, (_, $1) => '.******'))(/\.(\d+)/)
  },

  // 金融数字, 最后进行校验, 正则范围比较广
  {
    type: 'FINANCIAL_DIGIT',
    match: /^-?(\d+[,，](?=\d{3}))*\d+(\.\d{1,2})?$/,
    request: false,
    format: (str) => '******'
  }
]

let defaultFormater = {
  type: 'default',
  request: false,
  format: (a) => a
}

export function getRule(str, key) {
  for (let i = 0, length = rules.length; i < length; i++) {
    if (rules[i].match.test(str)) {
      return rules[i]
    }
  }
  warn('there is no suitable rule', `${key ? 'key: ' + key + ', ' : ''}value: ${str}`)
  return defaultFormater
}

export function changeDefaultFormat(format) {
  if (typeof format === 'function') {
    defaultFormater.format = format
  }
}

export function addRule(rule) {
  if (typeof rule === 'object') {
    if (rule instanceof Array) {
      return rule.forEach(addRule)
    }

    const { type, request = true, match, format } = rule
    if (match instanceof RegExp && typeof format === 'function') {
      rules.push({
        type,
        request,
        match,
        format
      })
    } else {
      warn(`wrong rule: ${type} , the match should be a RegExp, format should be a function`)
    }
  }
}
